import { loading, processedData, isAuthorized, hasPropertyId, dateRange, isConnected } from '../state';
import dayjs from 'dayjs';
import services from '../../../services';

/**
 * Analytics verilerini getir
 * @param {string} assetId - Asset ID
 */
export async function fetchAnalyticsData(assetId) {
  loading.value = true;
  
  try {
    const result = await services.analytics.getAnalyticsData(
      assetId,
      dateRange.value.start,
      dateRange.value.end
    );
    
    // Yetkilendirme durumlarını güncelle
    isAuthorized.value = result.isAuthorized;
    isConnected.value = result.isAuthorized; // Auth hatası varsa bağlantı da kesilmiş demektir
    hasPropertyId.value = result.hasPropertyId;
    
    // Veriyi güncelle
    if (result.processedData) {
      processedData.value = result.processedData;
    }
    
    // API yanıtında tarih aralığı bilgisi varsa, tarih seçicisini güncelle
    if (result.startDate && result.endDate) {
      try {
        dateRange.value = {
          start: dayjs(result.startDate).toDate(),
          end: dayjs(result.endDate).toDate(),
        };
      } catch (err) {
        // Hata sessizce yönetildi
      }
    }
  } catch (error) {
    // 401 hata kodunu yakala (Google API auth hatası)
    const errorStatus = error.response?.status;
    const errorData = error.response?.data?.data;
    
    if (errorStatus === 401 || 
        (errorData?.errorType === "ANALYTICS_DATA" && errorData?.isAuthError === true)) {
      isAuthorized.value = false;
      isConnected.value = false;
    }
  } finally {
    loading.value = false;
  }
}